<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>{{isStep}}. User Add-ons</v-card-title>
        <v-card-text>
          <template v-for="(user,i) in users">
            <span :key="i">
              <b>{{user.id}}</b> <br>
              <template v-for="(group, groupi) in user.addons">
                <template v-if="groupi==='no_group'">
                  <span :key="groupi">
                    <template v-for="(ad, ai) in group.items">
                      <span :key="ai" :class="`${getChanged(ad).color}--text`">
                        {{ad.name}} £{{ad.price.toFixed(2)}} <b class="float-right">{{getChanged(ad).text}}</b><br>
                      </span>
                    </template>
                  </span>
                </template>
                <template v-else>
                  <span :key="groupi" :class="`${getChangedGroup(group).color}--text`">
                    <br>
                    {{group.name}} <b class="float-right">{{getChangedGroup(group).text}}</b><br>
                    <template v-if="group.selected!==false&&group.selected!==null">{{getAddonName(group.selected)}} £{{group.price.toFixed(2)}} <br></template>
                    <template v-else>None<br></template>
                  </span>
                </template>
              </template>
              <div>
                <template v-for="(value, key) in unavailable">
                  <template v-if="user.id == key">
                    <div v-for="(addon, un) in value" :key="un">
                      <div class="d-flex align-center justify-space-between error--text">
                        <span>{{ addon.name }} - {{ addon.standard_price | formatCurrency }}</span>
                        <div class="d-flex align-center">
                          <span class="font-weight-bold mr-1">unavailable</span>
                          <v-tooltip top :key="i">
                            <template v-slot:activator="{on,attrs}">
                              <v-icon v-bind="attrs" v-on="on" small>{{mdiHelpCircle}}</v-icon>
                            </template>
                            <span>This add on has been removed because it is no longer available</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
              <template v-if="(i+1)<users.length">
                <v-divider class="my-2"></v-divider>
              </template>
            </span>
          </template>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import changeDetection from './../../../mixins/ChangeTariffDetection.js';
  import { mdiHelpCircle } from '@mdi/js';
  
  export default {
    data() {
      return {
        mdiHelpCircle
      }
    },
    props: [ 'isStep','users','userAddons','unavailable' ],
    mixins: [changeDetection],
    methods: {
      getAddonName(id){
        return (this.userAddons[id]!==undefined)?this.userAddons[id].name:'-';
      },
    },
  }
</script>

<style lang="scss" scoped></style>
